module.exports = __webpack_public_path__ + "img/6.700eba09.png";